import React, {Component} from 'react';
import styled from 'styled-components'

import {withFirebase} from "../../components/Firebase";
import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex, Heading, Image} from 'rebass';
import UserList from '../../components/UserList'
import {FloatingButton} from "../../components/Base/Buttons";
import {maxHeight} from "styled-system";
import check from '../../resources/img/icons/Checkbox@1x.png'
import {MetaText} from "../../components/Base/Text";
import IosArrowDown from 'react-ionicons/lib/IosClose'
import BasicSearch from '../../components/Forms/BasicSearch'
import {DesktopBox, Toolbar} from "../../components/Base";
import { filterStudentsByName } from "../../utils"; 

const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
`;


const Wrapper = styled(Box)`
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ${maxHeight}
`

const MobileWrapper = styled(Box)`	
	 @media (min-width: 700px){
		display: none;
	 }
`;


Wrapper.defaultProps = {
	maxHeight: ['calc(100vh - 165px)']
};

class Share extends Component {

	state = {
		selected: [],
		searchTerm: ''
	};

	componentDidMount() {
		const {roster} = this.props;
		let selected = roster.shared_with || [];
		if(!selected.includes(roster.creator_uid))
			selected.push(roster.creator_uid);
		this.setState({selected})
	}

	handleSelect = (details) => {
		let {selected} = this.state;
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({selected})
		}

	};

	handleSave = () => {
		const {selected} = this.state;
		const {handleSave, toggleVisible} = this.props;

		handleSave(selected);
		toggleVisible()
	};

	handleSearchInput = (e) => {
		this.setState({searchTerm: e.target.value})
	}

	render() {
		const {visible, toggleVisible, faculty, profile} = this.props;
		const {selected, searchTerm} = this.state;
		// console.log('checkin students', students)
		// if(students !== undefined || students !== null){
		// 	// users = students
		// }

		let users = faculty;
		if (profile && profile.id) {
			users = faculty.filter(user => user.id !== profile.id)
		}
		users = filterStudentsByName(users, searchTerm);
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} visible={visible}>
							<FloatingButton onClick={this.handleSave}><Image src={check}/></FloatingButton>
							 
							<Box>
								<Flex>
									<Box>
										<IosArrowDown onClick={toggleVisible} size={'40px'}/>
									</Box>
								</Flex>
								<DesktopBox> 
									<Toolbar py={2} bg={'white'} color={'black'} boxShadow={['none']}>
										<Box>
											<Heading pt={3}>Share Roster</Heading>
											<MetaText pb={2} fontSize='21px'>{selected && selected.length} shared</MetaText>
										</Box>
										<Box ml={'auto'}/>
										<Box width={1 / 2} pr={2}>
											<BasicSearch placeholder={'Search students...'} search={searchTerm} handleInput={this.handleSearchInput}/>
										</Box>
									</Toolbar>
								</DesktopBox>
								<MobileWrapper >
										<Box>
											<Heading pt={3}>Share Roster</Heading>
											<MetaText pb={2} fontSize='21px'>{selected && selected.length} shared</MetaText>
										</Box>
										<Box ml={'auto'}/>
										<Box width={1} pr={2}>
											<BasicSearch placeholder={'Search students...'} search={searchTerm} handleInput={this.handleSearchInput}/>
										</Box>
								</MobileWrapper>
								<Wrapper>
									<UserList students={users} handleUserClick={this.handleSelect} selected={selected}/>
								</Wrapper>
							</Box>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

export default withFirebase(Share)
